module.exports = "<div class=\"rw-clear-field-container\">\r\n    <i class=\"fa fa-close rw-clear-field\"\r\n       ng-if=\"rwClearField.ngModel.$viewValue\"\r\n       ng-click=\"rwClearField.onClear()\">\r\n    </i>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-clear-field/rw-clear-field.html
// module id = 1911
// module chunks = 0